import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

class BeaconSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: props.title || 'Beacon',
      label: 'name',
      url: 'integration/v1/beacons'
    };
  }
}

BeaconSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default BeaconSelector;
// withTracker(() => {
//   const items = Utils.enumTypesToArray(Checkpoints.Type);
//   // console.log('[CP type selector] items: ', items);
//   const subscription = {
//     ready: () => true
//   };
//   return {
//     subscription,
//     items,
//     title: 'Type'
//   };
//
// })(CheckpointTypeSelector);



// WEBPACK FOOTER //
// ./src/bluzone/beacon/BeaconSelector.js